import React, { useState, useContext } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import { Button, Chip, IconButton, Menu, MenuItem, Box } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Cancel, CheckCircle, EditNoteOutlined } from '@mui/icons-material';
import ChannelTableHead from './ChannelTableHead'
import { ChannelContext, CommonContext } from '../../context';
import TableSkeleton from '../common/TableSkeleton';
import commonApi from '../../utils/api';
import moment from 'moment/moment';
import { baseUrl, pickupStatus } from '../../utils/config';
import { Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import shopifyLogo from '../assets/img/Shopify-Logo.png';
// import wocoomerceLogo from '../assets/img/Woocommerce.png';

function createData(id, merchant_id, merchant_warehouse_id, del_boy_id, status, state, created_at, updated_at,) {
  return {
    id,
    merchant_id,
    merchant_warehouse_id,
    del_boy_id,
    status,
    state,
    created_at,
    updated_at,
  };
}

const rows = [
  createData(719, '3D Marketing Clutch (OPC) Private Limited', 'Tarun@marketingclutch.com', '15-09-2023', '15-09-2023', 'Prepaid', 0.00,),
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function ChannelTable() {
  const { allPickupRequest, firstLoading, setViewData, handleAddModal, setIsLoading, setIsEdit, onLoadApi } = useContext(ChannelContext)
  const { setOpenAlert, setAlertMessage, setSeverity } = useContext(CommonContext);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('created_at');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  // const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [anchorEl, setAnchorEl] = useState(null);

  const safeData = allPickupRequest || [];

  const clickMore = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMore = () => {
    setAnchorEl(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = safeData.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handleChangeDense = (event) => {
  //   setDense(event.target.checked);
  // };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - safeData.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(safeData, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, safeData],
  );
  const viewDetail = (id) => {
    setIsEdit(true);
    setIsLoading(true);
    commonApi.post('channel-integration/view-channel', { id: id })
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.data) {
          setViewData(response?.data?.data);
          handleAddModal();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error fetching data:', error);
      });
  }
  const toggleStatus = (id, status) => {
    setIsLoading(true);
    commonApi.post('channel-integration/status', { id: id, status: status })
      .then((response) => {
        setIsLoading(false);
        setOpenAlert(true);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        if (response?.data?.s === 1) {
          setAlertMessage(response?.data?.msg);
          setSeverity('success');
          onLoadApi();
        } else {
          setAlertMessage(response?.data?.msg);
          setSeverity('error')
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setOpenAlert(true);
        setAlertMessage(error?.response?.data?.msg || error?.message || 'Something went wrong');
        setSeverity('error')
        console.error('Error fetching data:', error);
      });
  }
  return (
    <div className='table-component'>
      {firstLoading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mb: 1 }}>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 150, 200, 250]}
            component="div"
            count={safeData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      ) : null}
      <TableContainer>
        <Table size="small">
          <ChannelTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={safeData.length}
          />
          <TableBody>
            {!firstLoading ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ p: 0 }}>
                  <TableSkeleton rows={7} columns={6} />
                </TableCell>
              </TableRow>
            ) : visibleRows.length > 0 ? (
              visibleRows.map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row.id}
                  >
                    <TableCell component="th" id={labelId} scope="row">
                      <strong>{row?.channel_type_id === 1 ? 'Shopify' : 'Woocommerce'}</strong>
                    </TableCell>
                    <TableCell align="left">{row?.channel_name}</TableCell>
                    <TableCell align="left">{row?.shopify_store_name}</TableCell>
                    <TableCell align="left">{row.shopify_app_token}</TableCell>
                    <TableCell align="left">
                      <CopyToClipboard
                        text={
                          row?.channel_type_id === 1
                            ? `${baseUrl}/channel-integration/get-shopify-orders/${row?.webhook_value}`
                            : `${baseUrl}/channel-integration/get-wocoomerce-orders/${row?.webhook_value}`
                        }
                      >
                        <Tooltip title="Copy Webhook URL">
                          <Chip
                            label="Copy URL"
                            icon={<ContentCopyIcon />}
                            clickable
                            color="primary"
                            size="small"
                          />
                        </Tooltip>
                      </CopyToClipboard>
                    </TableCell>
                    <TableCell align="left">{row.created_at ? moment(row.created_at).format('DD-MM-YYYY') : 'NA'}</TableCell>
                    <TableCell align="left">{row.updated_at ? moment(row.updated_at).format('DD-MM-YYYY') : 'NA'}</TableCell>
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip
                          variant="outlined"
                          label={row?.status === 1 ? 'Active' : 'InActive'}
                          color={row?.status === 1 ? 'success' : 'error'}
                          size="small"
                          className="cutom-table-chip"
                          icon={row?.status === 1 ? <CheckCircle fontSize="small" /> : <Cancel fontSize="small" />}
                          onClick={() => toggleStatus(row.id, row?.status === 1 ? 0 : 1)}
                        />
                        <Chip
                          variant="outlined"
                          label={'Edit'}
                          color={'default'}
                          size="small"
                          className="cutom-table-chip"
                          icon={<EditNoteOutlined fontSize="small" />}
                          onClick={() => viewDetail(row.id)}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}